import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
import { maximumStretchedWidth, maximumWidth, } from '@polestar/component-warehouse-react/tokens/breakpoints/Breakpoints';
import Grids from '@polestar/component-warehouse-react/tokens/grids/Grids';
import { css } from '@emotion/react';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { createCSSTransition, MotionDurations, MotionEasings, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import { getCurrentBackgroundColor } from './Section.helpers';
const Section = forwardRef(({ children, backgroundColor, media = false, stretchHeight, ...props }, ref) => {
    let content = children;
    if (!media) {
        content = React.createElement(SectionInner, { stretchHeight: stretchHeight }, children);
    }
    return (React.createElement(Container, { ...props, ref: ref, backgroundColor: backgroundColor, media: media }, content));
});
Section.displayName = 'Section';
export default Section;
export const MediaSection = forwardRef((props, ref) => (React.createElement(Section, { ...props, ref: ref, media: true })));
MediaSection.displayName = 'MediaSection';
export const CTASection = forwardRef(({ children, backgroundColor, ...props }, ref) => (React.createElement(Container, { ...props, ref: ref, media: true },
    React.createElement(CTAWrapper, { backgroundColor: backgroundColor },
        React.createElement(SectionInner, null, children)))));
CTASection.displayName = 'CTASection';
const CTAWrapper = styled.div(({ theme, backgroundColor }) => {
    const currentBackgroundColor = getCurrentBackgroundColor(theme._type, backgroundColor);
    return (currentBackgroundColor &&
        css `
        background-color: ${currentBackgroundColor};
      `);
});
/**
 * @internal
 */
export const sectionContainerPaddings = {
    paddingInlineStart: {
        mobile: Grids.mobile.gutter,
        tablet: Grids.tablet.gutter,
        desktop: Grids.desktop.gutter,
    },
    paddingInlineEnd: {
        mobile: Grids.mobile.gutter,
        tablet: Grids.tablet.gutter,
        desktop: Grids.desktop.gutter,
    },
};
const Container = styled('section', shouldNotForwardProps(true, 'media'))(({ theme, media, backgroundColor }) => {
    const currentBackgroundColor = getCurrentBackgroundColor(theme._type, backgroundColor);
    return css(css `
      width: 100%;
      position: relative;
      margin: 0 auto;

      ${responsiveStyles(sectionContainerPaddings)}
    `, currentBackgroundColor &&
        css `
        background-color: ${currentBackgroundColor};
      `, !!media &&
        css `
        max-width: ${maximumStretchedWidth}px;
      `);
});
export const SectionInner = forwardRef((props, ref) => (React.createElement(InnerContainer, { ref: ref, ...props })));
SectionInner.displayName = 'SectionInner';
/**
 * @internal
 */
export const sectionInnerStyling = {
    padding: {
        mobile: `0 ${Grids.mobile.gutter}`,
        tablet: `0 ${Spacings.large}`,
        desktop: `0 ${Spacings.xLarge}`,
        desktopWide: `0 ${Spacings.xxxxLarge}`,
    },
    maxWidth: {
        mobile: '100%',
        desktopWide: `${maximumWidth}px`,
    },
};
const InnerContainer = styled.div(({ stretchHeight }) => css(css `
      position: relative;
      width: 100%;
      margin: 0 auto;
      transition: ${createCSSTransition('padding', MotionEasings.easeOut, MotionDurations.fast)};

      ${responsiveStyles(sectionInnerStyling)}
    `, stretchHeight &&
    css `
        height: 100%;
      `));
